// material-ui
import {
  CardActions,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { Button, Divider, Grid, Typography } from '@mui/material'
import rq from 'components/RedQuick'
import RedQuickAlert from 'components/RedQuickAlert'
import { uuid } from 'components/util'
import * as SC from 'features/shared_components'
import TitleService from 'title-service'
import MainCard from 'ui-component/cards/MainCard'
import AnimateButton from 'ui-component/extended/AnimateButton'

import { gridSpacing } from 'store/constant'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import Busy from 'components/Busy'
import CoherentScreenControls from 'components/CoherentScreenControls'
import CoherentScreenForm from 'components/CoherentScreenForm'
import { getUserClaims } from 'features/application/application-slice'
import { get_all_approvedSeries } from 'features/approvedSeries/approvedSeries-slice'
import {
  get_all_coherentScreen,
  get_selected_coherentScreen,
  is_coherentScreen_busy,
  setSelectedcoherentScreen,
} from 'features/coherentScreen/coherentScreen-slice'
import { get_all_curatedMediaList } from 'features/curatedMediaList/curatedMediaList-slice'
import { get_all_curatedSeriesList } from 'features/curatedSeriesList/curatedSeriesList-slice'
import { get_all_releaseScheduleAction } from 'features/releaseScheduleAction/releaseScheduleAction-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let coherentScreen_list = useSelector(get_all_coherentScreen)
  let coherentScreen_busy = useSelector(is_coherentScreen_busy)
  let coherentScreen = useSelector(get_selected_coherentScreen)
  let curatedMediaList_list = useSelector(get_all_curatedMediaList)
  let releaseScheduleAction_list = useSelector(get_all_releaseScheduleAction)
  let curatedSeriesList_list = useSelector(get_all_curatedSeriesList)
  let approvedSeries_list = useSelector(get_all_approvedSeries)
  const [modelChanges, setModelChanges] = React.useState(null)
  const [modelValid, setModelValid] = React.useState(null)
  const [contextId, setContextId] = React.useState(null)
  const [modelDirty, setModelDirty] = React.useState(null)
  const [releaseActionArgs, setReleaseActionArgs] = React.useState(null)

  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_coherent_screen_list({ ok: false }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.load_curated_media_list({ ok: false }))
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.player) {
      dispatch(
        autoThunks.get_release_schedule_actions_for_coherent_screens({
          ok: false,
        }),
      )
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.player && coherentScreen?.id) {
      dispatch(
        autoThunks.get_release_schedule_actions_for_coherent_screen_list({
          id: (() => {
            function getModelId(): any {
              return coherentScreen?.id
            }
            return getModelId()
          })(),
        }),
      )
    }
  }, [claims?.player, coherentScreen?.id])
  useEffect(() => {
    if (claims?.player && coherentScreen?.id && releaseActionArgs) {
      dispatch(
        autoThunks.update_release_schedule_actions_for_coherent_screens({
          args: (() => {
            function getReleaseScheduleActionArgs(): any {
              return releaseActionArgs
            }
            return getReleaseScheduleActionArgs()
          })(),
        }),
      )
    }
  }, [claims?.player, coherentScreen?.id, releaseActionArgs])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.load_curated_series_list({ ok: false }))
    }
  }, [claims?.user])
  useEffect(() => {
    if (claims?.player) {
      dispatch(autoThunks.get_approved_series({ ok: false }))
    }
  }, [claims?.player])
  useEffect(() => {
    if (claims?.user) {
      dispatch(autoThunks.get_default_coherent_screen({ ok: false }))
    }
  }, [claims?.user])

  function get_current_model() {
    return {
      ...(coherentScreen || {}),
      ...(modelChanges || {}),
    }
  }

  function get_current_model_changes() {
    return {
      ...(modelChanges || {}),
    }
  }

  function modelComponent(): any {
    return (
      <>
        {SC.sharedList(
          (coherentScreen_list || [])
            .filter((x) => !x.deleted)
            .filter((x) => !x.owner),
          SC.sharedListItemBuilder,
          (item) => {
            return {
              name: item?.name || TitleService('Unknown'),
              date: item?.created || item.updated,
              statusColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.dark.main
                  : theme.palette.primary.light,
              getIcon: () => {
                return (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-device-tablet"
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#fd0061"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <rect x="5" y="3" width="14" height="18" rx="1" />
                    <circle cx="12" cy="17" r="1" />
                  </svg>
                )
              },
            }
          },
          (item) => {
            dispatch(setSelectedcoherentScreen(item?.id))
            setModelChanges({})
            setModelValid(null)
            setModelDirty(null)
            setContextId(uuid())
          },
        )}
      </>
    )
  }

  let output_modelComponent = modelComponent()

  function modelItemForm(storeModelAsync: any, deleteModelAsync: any): any {
    return (
      <>
        <CoherentScreenControls coherentScreen={coherentScreen} />
        <Grid item xs={12} sm={12} md={12}>
          <CoherentScreenForm
            page={undefined}
            form={get_current_model()}
            onUpdate={(update, valid, dirty) => {
              setModelChanges({
                ...modelChanges,
                ...update,
              })
              setModelValid(valid)
              setModelDirty(dirty)
            }}
            context={{
              id: contextId,
            }}
          />
          <SC.CoherentScreenReleaseAction
            coherentScreen={coherentScreen}
            actions={releaseScheduleAction_list}
            onChange={(args) => {
              setReleaseActionArgs(args)
            }}
          />
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                <InputLabel id="highlistSeries-label">
                  {TitleService('Highlight Series')}
                </InputLabel>
                <Select
                  labelId="highlistSeries-label"
                  id="highlistSeries-select"
                  value={get_current_model()?.highlightSeriesId || ''}
                  label={TitleService('Highlight Series')}
                  onChange={(val: any) => {
                    let temp = get_current_model()
                    temp.highlightSeriesId = val.target.value
                    setModelChanges({
                      ...temp,
                    })
                    setModelDirty(true)
                    setModelValid(
                      modelValid === null ? true : modelValid && true,
                    )
                  }}
                >
                  <MenuItem value="">{TitleService('Select Series')}</MenuItem>
                  {(approvedSeries_list || []).map((item) => {
                    return (
                      <MenuItem value={item.seriesId} key={item.seriesId}>
                        {item?.series?.name}
                      </MenuItem>
                    )
                  })}
                </Select>
                <FormHelperText>
                  {TitleService('Select a series')}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              {SC.sharedList(
                (curatedMediaList_list || [])
                  .filter((x) => !x.deleted)
                  .filter((x) => !x.owner)
                  .filter((x) => {
                    let temp = get_current_model()
                    if (temp?.orderedReferenceList?.indexOf(x.id) !== -1) {
                      return false
                    }
                    return true
                  }),
                SC.sharedListItemBuilder,
                (item) => {
                  return {
                    name: item?.name || TitleService('Unknown'),
                    date: item?.created || item.updated,
                    statusColor:
                      theme.palette.mode === 'dark'
                        ? theme.palette.dark.main
                        : theme.palette.primary.light,
                    getIcon: () => {
                      return (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-list-details"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="#597e8d"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M13 5h8" />
                          <path d="M13 9h5" />
                          <path d="M13 15h8" />
                          <path d="M13 19h5" />
                          <rect x="3" y="4" width="6" height="6" rx="1" />
                          <rect x="3" y="14" width="6" height="6" rx="1" />
                        </svg>
                      )
                    },
                  }
                },
                (item) => {
                  let temp = get_current_model()
                  temp.orderedReferenceList = [
                    ...(temp.orderedReferenceList || []),
                  ]
                  if (!temp.orderedReferenceList.some((v) => v === item?.id)) {
                    temp.orderedReferenceList.push(item?.id)
                    setModelChanges(temp)
                    setModelValid(
                      modelValid !== null ? modelValid && true : true,
                    )
                    setModelDirty(true)
                  }
                },
              )}
            </Grid>
            <Grid item xs={3} sm={3} md={3}>
              {SC.sharedList(
                (curatedSeriesList_list || [])
                  .filter((x) => !x.deleted)
                  .filter((x) => {
                    let temp = get_current_model()
                    if (
                      temp?.orderedReferenceList &&
                      temp?.orderedReferenceList?.indexOf(x.id) !== -1
                    ) {
                      return false
                    }
                    return true
                  }),
                SC.sharedListItemBuilder,
                (item) => {
                  return {
                    name: item?.name || TitleService('Unknown'),
                    date: item?.created || item.updated,
                    statusColor:
                      theme.palette.mode === 'dark'
                        ? theme.palette.dark.main
                        : theme.palette.primary.light,
                    getIcon: () => {
                      return (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon icon-tabler icon-tabler-list-details"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="#597e8d"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M13 5h8" />
                          <path d="M13 9h5" />
                          <path d="M13 15h8" />
                          <path d="M13 19h5" />
                          <rect x="3" y="4" width="6" height="6" rx="1" />
                          <rect x="3" y="14" width="6" height="6" rx="1" />
                        </svg>
                      )
                    },
                  }
                },
                (item) => {
                  let temp = get_current_model_changes()
                  temp.orderedReferenceList = temp.orderedReferenceList || []
                  if (!temp.orderedReferenceList.some((v) => v === item?.id)) {
                    temp.orderedReferenceList.push(item?.id)
                    setModelChanges(temp)
                    setModelValid(
                      modelValid !== null ? modelValid && true : true,
                    )
                    setModelDirty(true)
                  }
                },
              )}
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <Typography variant="h5" sx={{ m: 0 }}>
                {TitleService('Coherent Screens Order')}
              </Typography>
              <rq.RedQuickOrderedList
                value={(get_current_model().orderedReferenceList || []).map(
                  (v) => ({ id: v }),
                )}
                rowHeight={60}
                createElement={(item) => {
                  let curatedMediaList_item = curatedMediaList_list.find(
                    (v) => v.id === item.i,
                  )
                  if (curatedMediaList_item) {
                    return SC.renderCuratedMediaListItem(
                      curatedMediaList_item,
                      theme,
                      () => {
                        let temp = get_current_model()
                        temp.orderedReferenceList =
                          temp.orderedReferenceList || []
                        temp.orderedReferenceList =
                          temp.orderedReferenceList.filter((x) => x !== item.i)
                        setModelChanges(temp)
                        setModelValid(
                          modelValid !== null ? modelValid && true : true,
                        )
                        setModelDirty(true)
                      },
                    )
                  }
                  let curatedSeriesList_item = curatedSeriesList_list.find(
                    (v) => v.id === item.i,
                  )
                  if (curatedSeriesList_item) {
                    return SC.renderCuratedSeriesListItem(
                      curatedSeriesList_item,
                      theme,
                      () => {
                        let temp = get_current_model()
                        temp.orderedReferenceList =
                          temp.orderedReferenceList || []
                        temp.orderedReferenceList =
                          temp.orderedReferenceList.filter((x) => x !== item.i)
                        setModelChanges(temp)
                        setModelValid(
                          modelValid !== null ? modelValid && true : true,
                        )
                        setModelDirty(true)
                      },
                    )
                  }
                  return <></>
                }}
                onChange={(items) => {
                  console.log(items)
                  let temp = get_current_model()
                  if (!temp.orderedReferenceList) {
                    temp.orderedReferenceList =
                      get_current_model()?.orderedReferenceList
                  }

                  temp.orderedReferenceList = temp.orderedReferenceList || []
                  if (
                    JSON.stringify(temp.orderedReferenceList) !==
                    JSON.stringify(items.map((v) => v.i))
                  ) {
                    temp.orderedReferenceList = items.map((v) => {
                      return v.i
                    })
                    setModelChanges(temp)
                    setModelValid(
                      modelValid !== null ? modelValid && true : true,
                    )
                    setModelDirty(true)
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Divider />
        <CardActions sx={{ p: 1.25, justifyContent: 'center' }}>
          <Grid container spacing={2}>
            <Grid item>
              <AnimateButton>
                <Button
                  variant="contained"
                  onClick={async () => {
                    dispatch(setSelectedcoherentScreen(null))
                    setModelChanges({})
                    setModelValid(null)
                    setModelDirty(null)
                  }}
                >
                  {TitleService('New')}
                </Button>
              </AnimateButton>
            </Grid>
            {modelDirty && modelValid && (
              <Grid item>
                <AnimateButton>
                  <Button
                    variant="contained"
                    onClick={async () => {
                      await dispatch(storeModelAsync)
                      setModelChanges({})
                      setModelValid(null)
                      setModelDirty(null)
                      setContextId(uuid())
                    }}
                  >
                    {TitleService('Save')}
                  </Button>
                </AnimateButton>
              </Grid>
            )}
            {get_current_model()?.id &&
              get_current_model()?.id !== 'default_screen' && (
                <Grid item>
                  <RedQuickAlert
                    button={
                      <Button
                        variant="contained"
                        sx={{
                          background: theme.palette.error.main,
                          '&:hover': { background: theme.palette.error.dark },
                        }}
                        disabled={coherentScreen_busy}
                        onClick={async () => {}}
                      >
                        {TitleService('Delete')}
                      </Button>
                    }
                    cancelText={TitleService('No')}
                    affirmativeText={TitleService('Yes')}
                    onOk={async () => {
                      await dispatch(deleteModelAsync)
                      dispatch(setSelectedcoherentScreen(null))
                      setModelChanges({})
                      setModelValid(null)
                      setModelDirty(null)
                      setContextId(uuid())
                    }}
                    title={TitleService('Are you sure?')}
                    description={TitleService('This is a system wide change.')}
                  />
                </Grid>
              )}
          </Grid>
        </CardActions>
      </>
    )
  }

  let output_modelItemForm = modelItemForm(
    autoThunks.storeCoherentScreenAsync({
      model: (() => {
        function getCoherentScreen(): any {
          return {
            ...(coherentScreen || {}),
            ...(modelChanges || {}),
            lastUpdatedBy: claims?.player,
          }
        }
        return getCoherentScreen()
      })(),
    }),
    autoThunks.deleteCoherentScreenAsync({
      id: (() => {
        function getModelId(): any {
          return coherentScreen?.id
        }
        return getModelId()
      })(),
    }),
  )

  function main_card(modelList: any, modelForm: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Busy />
        <Grid item xs={12} xl={3} md={3}>
          <MainCard title={TitleService('Coherent Screens')}>
            {modelList}
          </MainCard>
        </Grid>
        <Grid item xs={12} xl={9} md={9}>
          <MainCard
            title={coherentScreen?.name || TitleService('Coherent Screen')}
          >
            {modelForm}
          </MainCard>
        </Grid>
      </Grid>
    )
  }

  let output_main_card = main_card(output_modelComponent, output_modelItemForm)

  return output_main_card
}
